import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./App.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
    // </React.StrictMode>
);


